import { catchError, lastValueFrom, Observable, of, takeUntil } from 'rxjs';
import { DropdownModel, ErrorHandlingService } from '../core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

export async function filterEntities(
  service: { suggest: (query: string) => Observable<any>; [key: string]: any },
  setFilteredData: (result: DropdownModel[]) => void,
  event: AutoCompleteCompleteEvent,
  isValue?: boolean,
  method: string = 'suggest',
  cancel$?: Observable<unknown>,
  errorHandler?: ErrorHandlingService,
): Promise<void> {
  const { query } = event;

  if (!query) {
    setFilteredData([]);
  }

  let source$ = service[method](query);

  if (cancel$) {
    source$ = source$.pipe(takeUntil(cancel$));
  }

  let result: DropdownModel[] = await lastValueFrom(
    source$.pipe(
      catchError((error) => {
        if (errorHandler) {
          errorHandler.handleError(error, 'Error retrieving data.');
        }
        return of([]);
      }),
    ),
  );

  result = result.filter((x) => x.id && x.description);

  if (isValue && result.length === 0) {
    result = [{ id: query, description: '' }];
  }

  setFilteredData(result);
}
